// ABOUTME: Confirmation dialog for removing a child from the family
// ABOUTME: Warns about data loss and confirms removal action

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@mui/material';
import type { ChildInfo } from '../types';

interface RemoveChildDialogProps {
  open: boolean;
  child: ChildInfo | null;
  removing: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const RemoveChildDialog: React.FC<RemoveChildDialogProps> = ({
  open,
  child,
  removing,
  onClose,
  onConfirm
}) => {
  if (!child) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="remove-child-confirmation"
    >
      <DialogTitle>Remove Child</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove <strong>{child.name}</strong> from your family?
        </Typography>
        <Typography sx={{ mt: 2, color: 'text.secondary' }}>
          This will remove the child and all their behavioral data including behaviors, goals, and progress.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={removing}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={removing}
        >
          {removing ? <CircularProgress size={24} /> : 'Remove Child'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveChildDialog;
